import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { PreventDefaultModule } from '@portal-core/general/directives/prevent-default/prevent-default.module';
import { StopPropagationModule } from '@portal-core/general/directives/stop-propagation/stop-propagation.module';
import { GridHeaderCellModule } from '@portal-core/ui/grid/components/grid-header-cell/grid-header-cell.module';
import { IndeterminatePaginatorModule } from '@portal-core/ui/grid/components/indeterminate-paginator/indeterminate-paginator.module';
import { AllItemsGridDirectiveModule } from '@portal-core/ui/grid/directives/all-items-grid/all-items-grid.module';
import { ContextMenuItemsModule } from '@portal-core/ui/grid/directives/context-menu-items/context-menu-items.module';
import { EmptyGridModule } from '@portal-core/ui/grid/directives/empty-grid/empty-grid.module';
import { ExpandedRowDetailModule } from '@portal-core/ui/grid/directives/expanded-row-detail/expanded-row-detail.module';
import { GridCellModule } from '@portal-core/ui/grid/directives/grid-cell/grid-cell.module';
import { GridHeaderMenuModule } from '@portal-core/ui/grid/directives/grid-header-menu/grid-header-menu.module';
import { HelpGridModule } from '@portal-core/ui/grid/directives/help-grid/help-grid.module';
import { LazyRenderModule } from '@portal-core/ui/lazy-render/directives/lazy-render/lazy-render.module';
import { GridComponent } from './grid.component';

@NgModule({
  imports: [
    CommonModule,
    ContextMenuItemsModule,
    EmptyGridModule,
    HelpGridModule,
    ErrorsExpansionPanelModule,
    ExpandedRowDetailModule,
    GridCellModule,
    GridHeaderCellModule,
    GridHeaderMenuModule,
    IndeterminatePaginatorModule,
    LazyRenderModule,
    LoaderModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    AllItemsGridDirectiveModule,
    PreventDefaultModule,
    StopPropagationModule
  ],
  declarations: [
    GridComponent
  ],
  exports: [
    GridComponent
  ]
})
export class GridComponentModule { }
